export const constants = {
  timers: {
    500: 500,
    1000: 1000,
    2000: 2000,
    2500: 2500,
    3000: 3000,
    4000: 4000,
    5000: 5000,
    6000: 6000,
    10000: 10000,
    60000: 60000,
    80000: 80000
  },
  screenMeasures: {
    48: 48,
    666: 666,
    769: 769,
    1171: 1171,
    1441: 1441
  },
  other: {
    leaderboardDataEndMs: 1663078860000,
    imgSrc768: 768,
    age21: 21
  },
  ports: {
    8080: 8080,
    8081: 8081
  },
  wallets: {
    cashWalletId: 102,
    diamondWalletId: 104,
    swcWalletId: 110,
    swtWalletId: 111,
    gcWalletId: 113
  }
}
